import React, { useState } from "react";
import {
  CreditCard,
  Check,
  Star,
  MessageCircle,
  Heart,
  ArrowLeft,
  Gift,
  Zap,
  Shield,
  Sparkles,
} from "lucide-react";

export default function PaymentPage() {
  const [isHovering, setIsHovering] = useState(false);

  const handlePayment = () => {
    // Esto sería reemplazado con tu enlace de pago Bold
    window.location.href = "https://checkout.bold.co/payment/LNK_KUTBYXGANU";
  };

  const handleWhatsApp = () => {
    window.open(
      "https://wa.me/573023580862?text=Hola%20ayuda%20con%20mi%20pago%20para%20el%20VIP",
      "_blank"
    );
  };

  const handleBack = () => {
    // Volver a la página anterior
    window.history.back();
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 to-black text-white flex flex-col">
      {/* Header mejorado - ancho completo */}
      <header className="bg-gradient-to-r from-indigo-900 to-purple-900 shadow-lg w-full py-4 px-4 sm:px-6 sticky top-0 z-50 border-b border-indigo-800">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <button
            onClick={handleBack}
            className="flex items-center text-indigo-200 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-5 w-5 mr-1" />
            <span>Regresar</span>
          </button>
          <div className="flex items-center space-x-1">
            <Shield className="h-5 w-5 text-indigo-300" />
            <span className="text-sm font-medium text-indigo-200">
              Pago Seguro
            </span>
          </div>
        </div>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center py-8 px-4">
        <div className="max-w-md w-full">
          {/* Tarjeta principal */}
          <div
            className="bg-gradient-to-b from-gray-900 to-gray-800 rounded-xl shadow-2xl overflow-hidden border border-gray-700 transform transition-all duration-300 hover:shadow-indigo-900/20"
            onMouseEnter={() => setIsHovering(true)}
            onMouseLeave={() => setIsHovering(false)}
          >
            {/* Cabecera de la tarjeta */}
            <div className="bg-gradient-to-r from-indigo-600 to-purple-600 px-6 py-8 text-center relative overflow-hidden">
              <div className="absolute top-0 right-0 p-3">
                <div className="animate-pulse">
                  <Heart className="h-6 w-6 text-pink-400 fill-pink-400" />
                </div>
              </div>

              <Sparkles className="h-6 w-6 text-yellow-300 mx-auto mb-2" />
              <h1 className="text-3xl font-bold mb-1">Plan VIP Premium</h1>
              <div className="mt-2 mb-1">
                <span className="text-4xl font-bold">$50,000 COP</span>
                <span className="text-sm ml-1">/mes</span>
              </div>
              <div className="text-indigo-200 text-sm mt-1">
                Facturación mensual • Cancela en cualquier momento
              </div>

              <div className="absolute -bottom-16 -right-16 opacity-10">
                <Star className="h-32 w-32" />
              </div>
            </div>

            {/* Beneficios */}
            <div className="px-6 py-6">
              <h2 className="text-xl font-semibold mb-4 flex items-center">
                <Star className="h-5 w-5 mr-2 text-yellow-400" />
                Beneficios Exclusivos
              </h2>

              <div className="space-y-3">
                <div className="flex items-center bg-gray-800/70 p-3 rounded-lg hover:bg-indigo-900/30 transition-all">
                  <Zap
                    className={`h-5 w-5 text-yellow-400 flex-shrink-0 ${
                      isHovering ? "animate-pulse" : ""
                    }`}
                  />
                  <p className="ml-3 text-gray-200">
                    Acceso ilimitado a contenido premium
                  </p>
                </div>

                <div className="flex items-center bg-gray-800/70 p-3 rounded-lg hover:bg-indigo-900/30 transition-all">
                  <Check className="h-5 w-5 text-green-400 flex-shrink-0" />
                  <p className="ml-3 text-gray-200">Soporte prioritario 24/7</p>
                </div>

                <div className="flex items-center bg-gray-800/70 p-3 rounded-lg hover:bg-indigo-900/30 transition-all">
                  <Gift className="h-5 w-5 text-purple-400 flex-shrink-0" />
                  <p className="ml-3 text-gray-200">
                    15% de descuento en todos los productos
                  </p>
                </div>

                <div className="flex items-center bg-gray-800/70 p-3 rounded-lg hover:bg-indigo-900/30 transition-all">
                  <Heart className="h-5 w-5 text-pink-400 flex-shrink-0" />
                  <p className="ml-3 text-gray-200">
                    Eventos exclusivos y acceso anticipado
                  </p>
                </div>
              </div>
            </div>

            {/* Detalles de pago */}
            <div className="px-6 py-4 border-t border-gray-700 bg-gray-900/50 flex justify-between items-center">
              <div className="flex items-center">
                <CreditCard className="h-5 w-5 text-indigo-300" />
                <span className="ml-2 text-sm text-indigo-300">
                  Pago 100% seguro
                </span>
              </div>
              <div className="text-xs px-2 py-1 bg-indigo-800 text-indigo-200 rounded-full">
                Powered by Bold
              </div>
            </div>

            {/* Botones de pago */}
            <div className="px-6 py-6 bg-gray-900/30">
              <button
                onClick={handlePayment}
                className="w-full py-4 mb-3 bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white font-bold rounded-lg shadow-lg transition-all transform hover:scale-105 flex items-center justify-center"
              >
                <CreditCard className="h-5 w-5 mr-2" />
                Proceder al Pago
              </button>

              <button
                onClick={handleWhatsApp}
                className="w-full py-3 bg-green-600 hover:bg-green-700 text-white font-bold rounded-lg shadow-lg transition-all flex items-center justify-center transform hover:scale-105"
              >
                <MessageCircle className="h-5 w-5 mr-2" />
                Ayuda por WhatsApp
              </button>
            </div>
          </div>

          {/* Información adicional */}
          <div className="mt-4 text-center">
            <p className="text-indigo-300 text-sm">
              Suscríbete hoy y desbloquea todos los beneficios VIP
            </p>
            <div className="mt-2 flex justify-center space-x-2">
              <CreditCard className="h-4 w-4 text-gray-500" />
              <Shield className="h-4 w-4 text-gray-500" />
              <Zap className="h-4 w-4 text-gray-500" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
